import cn from 'classnames';
import { QRCodeSVG } from 'qrcode.react';
import BaseModal from '@/components/modal/lib/BaseModal';
import Text from '@/components/common/Text/Text';

import './QRCodeModal.style.scss';
import { ProductCardData } from '@/types/Product';
import { productUrlIOSDeepLink } from '@/util/iosDeepLinks';

type QRCodeModalProps = {
  className?: string;
  onClose: () => void;
  url: string;
  product?: ProductCardData;
};

function QRCodeModal(props: QRCodeModalProps) {
  const { className = '', onClose, url, product } = props;

  if (!product) {
    return null;
  }

  let qrLink = url;

  if (product.store === 'vivrelle') {
    qrLink = productUrlIOSDeepLink(product.item_group_id || product.sku);
  }

  return (
    <BaseModal
      className={cn('QRCodeModal', className)}
      onClose={onClose}
    >
      <div className='QRCodeModal-content'>
        <Text
          variant='title-xl'
          uppercase
          className='QRCodeModal-title'
        >
          Scan to shop
        </Text>
        {product?.name && (
          <Text
            variant='text-l'
            className='QRCodeModal-product'
          >
            {product.name}
          </Text>
        )}
        <div className='QRCodeModal-code'>
          <QRCodeSVG
            value={qrLink}
            size={256}
            level='H'
            marginSize={4}
          />
        </div>
      </div>
    </BaseModal>
  );
}

export default QRCodeModal;
